<template>
	<ActivityInfomationCom />
</template>

<script>
import ActivityInfomationCom from '@/views/Shop/ApprovalQuery/main';
export default {
  name: 'ActivityInfomation',

  components:{
    ActivityInfomationCom
  },

  data () {
    return {
    }
  },

  computed: {

  },

  created() {
  },

  mounted() {},
}
</script>


<style lang='scss'>
</style>
